import React, { useState, useEffect } from 'react';
import { Box, useMediaQuery } from '@material-ui/core';
import { useTranslate, useDataProvider, Title, usePermissions } from 'react-admin';
import PageListLabel from './PageListLabel';
import RoleTable from './ListContentRole';

const RoleList = ({ }) => {
    const translate = useTranslate();
    const dataProvider = useDataProvider();
    const { permissions, loaded } = usePermissions();
    const isDesktop = useMediaQuery(theme => theme.breakpoints.up('md'));
    const [role, setRole] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [roleUser, setRoleUser] = useState();

    const getRoleList = (sort, pagination) => {
        dataProvider('GET_LIST', "roles", {
            filter: {

            },
            pagination,
            sort,
        }).then(({ data, total }) => {
            setRole(data);
            setTotalCount(total);
        }).catch(error => {
            console.error('Get list error:', error);
        });
    }
    React.useEffect(() => {
        if (localStorage.getItem('userData')) {
            var data = JSON.parse(localStorage.getItem('userData'))
            setRoleUser(data.permission.name)
        }
    }, []);

    useEffect(() => {
        const pagination = { page: 1, perPage: 10 };
        const sort = { field: 'id', order: 'DESC' };
        getRoleList(sort, pagination);
    }, []);
    if (!loaded) return null
    return (
        <Box mt={5} py={2} width={!isDesktop ? '95%' : '80%'} m='auto'>
            <Title title={translate(`pos.user.title`)} />
            <PageListLabel
                buttonHidden={!permissions.functionAction.find(value => value.function === 'Admin users' && value.isCreate)}
                label={translate('resources.role.title')}
                btnText={translate('resources.role.createrole')}
                pathname='/roles/create'
                total={totalCount}
            />
            <RoleTable
                buttonHidden={!permissions.functionAction.find(value => value.function === 'Admin users' && value.isUpdate)}
                data={role}
                total={totalCount}
                getRoleList={getRoleList}
                roleUser={roleUser}
            />
        </Box>
    );
}

export default RoleList;